// extracted by mini-css-extract-plugin
export default {"microficheRoot":"Microfiche_microficheRoot__zcEyY","zoomed":"Microfiche_zoomed__X1i9A","microficheImages":"Microfiche_microficheImages__cBoUn","image":"Microfiche_image__cQK2g"};